import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../lib/metaPixel';
export function Hero() {
  return <section className="w-full bg-botanic relative overflow-hidden" data-id="element-60">
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-sage to-transparent pointer-events-none" data-id="element-61"></div>

      <div className="max-w-[1200px] mx-auto px-6 py-16 md:py-24 flex flex-col md:flex-row items-center gap-12 relative z-10" data-id="element-62">
        {/* Left Column */}
        <div className="flex-1 text-center md:text-left" data-id="element-63">
          <span className="inline-block bg-sage/20 text-sage-soft border border-sage/30 px-4 py-1.5 rounded-full text-sm font-semibold tracking-wide mb-6" data-id="element-64">
            🌿 NUEVO PACK 365 CENAS
          </span>

          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-gold leading-tight mb-6" data-id="element-65">
            ¿Y si esta noche pudieras cenar rico...
            <br data-id="element-66" />
            <span className="text-ivory" data-id="element-67">
              y despertar completamente descansado?
            </span>
          </h1>

          <p className="text-ivory/90 text-lg md:text-xl mb-8 max-w-xl mx-auto md:mx-0" data-id="element-68">
            Descarga las 365 recetas que están ayudando a adultos de 40+ a
            lograr un sueño profundo sin pasar hambre.
          </p>

          <div className="flex flex-col gap-3 mb-10 text-ivory/90 text-left max-w-md mx-auto md:mx-0" data-id="element-69">
            <div className="flex items-center gap-3" data-id="element-70">
              <CheckCircle2 className="text-gold w-6 h-6 shrink-0" data-id="element-71" />
              <span data-id="element-72">365 recetas listas en &lt; 20 min</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-73">
              <CheckCircle2 className="text-gold w-6 h-6 shrink-0" data-id="element-74" />
              <span data-id="element-75">Sin ingredientes raros ni costosos</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-76">
              <CheckCircle2 className="text-gold w-6 h-6 shrink-0" data-id="element-77" />
              <span data-id="element-78">Diseñado para el metabolismo de 40+</span>
            </div>
          </div>

          <motion.a href="https://www.legadosalud.com/cart/42654220582997:1" onClick={trackAddToCart} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block bg-gold text-white font-bold text-lg md:text-xl px-8 py-4 rounded-xl shadow-lg shadow-gold/20 hover:shadow-gold/40 transition-all" data-id="element-79">
            Descárgalo AHORA — $9.99
            <span className="block text-sm font-normal opacity-80 mt-1 line-through" data-id="element-80">
              $37 USD
            </span>
          </motion.a>
        </div>

        {/* Right Column - iPad Mockup */}
        <div className="flex-1 w-full max-w-md md:max-w-none relative" data-id="element-81">
          <div className="relative rounded-[2rem] p-3 bg-gradient-to-br from-gray-800 to-black shadow-2xl shadow-black/50 border border-gray-700" data-id="element-82">
            <div className="absolute top-1/2 -left-3 w-1 h-12 bg-gray-700 rounded-l-md" data-id="element-83"></div>
            <div className="absolute top-24 -right-3 w-1 h-16 bg-gray-700 rounded-r-md" data-id="element-84"></div>
            <div className="absolute top-48 -right-3 w-1 h-16 bg-gray-700 rounded-r-md" data-id="element-85"></div>

            <div className="rounded-[1.5rem] overflow-hidden bg-white aspect-[16/10] relative" data-id="element-86">
              <img src="https://cdn.magicpatterns.com/uploads/5BECy4yqhaByXVqabPsQjd/365_Cenas_-_Portada.png" alt="Portada 365 Cenas que te Ayudan a Soñar" className="w-full h-full object-contain" data-id="element-87" />
              {/* Warm light overlay */}
              <div className="absolute inset-0 bg-gradient-to-tr from-gold/10 to-transparent mix-blend-overlay pointer-events-none" data-id="element-88"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}